import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event-package';

@Component({
  standalone: false,
  selector: 'app-exposure-graph',
  templateUrl: './exposure-graph.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-graph.component.scss']
})
export class ExposureGraphComponent implements OnInit {
  @Input() selectedTab;
  @Input() loadCommentsAndNotes;
  @Input() isVideoChartHidden;
  @Input() CHART_VIDEO_DIV_ID;
  @Input() CHART_DIV_ID;
  @Input() showChartFilter;
  @Input() chart;
  @Input() chartDetails;
  @Input() taskRangeVisibility;

  @Output() clearCommentRangesEmit = new EventEmitter<any>();
  @Output() toggleShowChartFilterEmit = new EventEmitter<any>();
  @Output() onResizedEmit = new EventEmitter<any>();
  @Output() showNotesRangeEmit = new EventEmitter<any>();
  @Output() showTaskRangeEmit = new EventEmitter<any>();
  @Output() hideChartFilterEmit = new EventEmitter<any>();
  @Output() onVideoResizedEmit = new EventEmitter<any>();
  @Output() showTrendLinesEmit = new EventEmitter<any>();
  @Output() showCumulativeLinesEmit = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  clearCommentRanges(event) {
    this.clearCommentRangesEmit.emit(event);
  }

  toggleShowChartFilter() {
    this.toggleShowChartFilterEmit.emit(true);
  }

  onResized(event: ResizedEvent, chart, chartDivId: string) {
    this.onResizedEmit.emit({event, chart, chartDivId});
  }

  showNotesRange(visibility = false, taskId = 0) {
    this.showNotesRangeEmit.emit({visibility, taskId});
  }

  showTaskRange(visibility = false, taskName = null) {
    this.showTaskRangeEmit.emit({visibility, taskName});
  }

  showTrendLines(){
    this.showTrendLinesEmit.emit();
  }

  showCumulativeLines(){
    this.showCumulativeLinesEmit.emit();
  }

  hideChartFilter() {
    this.hideChartFilterEmit.emit(true);
  }

  onVideoResized(event) {
    this.onVideoResizedEmit.emit(event);
  }

}
